import React from 'react'
import { Input, Select, RadioGroup } from '@st-operations/uikit/src/v2/index.js'

import KeywordsInputWithRecommendations from '_components/keywords-input-with-recommendations/index.jsx'

const CustomAttributesForm = ({
  value = {
    type: 'custom_iscore',
    terms: [],
    alias: '',
    lookupMethod: '',
  },
  onChange,
}) => {
  const handleValuesChange = (values, name) => {
    onChange({ ...value, [name]: values.value || values })
  }

  return (
    <div style={{ overflow: 'auto', paddingRight: 12 }}>
      <Select
        label="Type"
        options={[{ label: 'Interest Score', value: 'custom_iscore' }]}
        value={'custom_iscore'}
        name="type"
        disabled
        useReactSelect
      />
      <Input label="Name" value={value?.alias} onChange={handleValuesChange} name="alias" />
      <RadioGroup
        options={[
          {
            value: 'exact_match',
            name: 'lookupMethod',
            label: 'Exact Match',
          },
          {
            value: 'similarity',
            name: 'lookupMethod',
            label: 'Similarity',
          },
        ]}
        onChange={({ target: { value, name } }) => handleValuesChange(value, name)}
        selected={value.lookupMethod}
      />
      <KeywordsInputWithRecommendations values={value?.terms} onChange={handleValuesChange} />
    </div>
  )
}

export default CustomAttributesForm
